module.exports = __webpack_public_path__ + "static/media/add_circle.606fb8f7.svg";